var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"full-screen",on:{"click":_vm.closeBanner}},[_c('button',{staticClass:"close-button"},[_vm._v("×")]),_c('img',{attrs:{"src":require("@/assets/img/banner-inauguracion.webp"),"alt":"Banner Inauguração"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }